import angular from "angular";
import user from "../user";
import core from "../../core/core.module";

angular
    .module('usersControl.userPermissions', [user, core])
    .component('userPermissions', {
        controller: ['User', '$timeout', 'notifier', controller],
        template: require('./user-permissions.html'),
        bindings: {
            user: '<',
            modules: '<',
            userPermissions: '<',
            userRoles: '<'
        }
    });

function controller(User, $timeout, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $timeout(function () {
            setPermissionsStatusThroughRoles();
            setDirectPermissionsStatus();
        });
    };

    function setPermissionsStatusThroughRoles() {
        $ctrl.userRoles.forEach(function (role) {
            role.permissions.forEach(function (permission) {
                for (let i = 0; i < $ctrl.modules.length; i++) {
                    if ($ctrl.modules[i].id == permission['module_id']) {
                        for (let j = 0; j < $ctrl.modules[i].permissions.length; j++) {
                            if ($ctrl.modules[i].permissions[j].id == permission.id) {
                                $ctrl.modules[i].permissions[j].byRole = true;
                                return;
                            }
                        }
                    }
                }
            });
        });
    }

    function setDirectPermissionsStatus() {
        $ctrl.userPermissions.forEach(function (permission) {
            for (let i = 0; i < $ctrl.modules.length; i++) {
                if ($ctrl.modules[i].id == permission['module_id']) {
                    for (let j = 0; j < $ctrl.modules[i].permissions.length; j++) {
                        if ($ctrl.modules[i].permissions[j].id == permission.id) {
                            $ctrl.modules[i].permissions[j].byPermission = true;
                            return;
                        }
                    }
                }
            }
        });
    }

    $ctrl.togglePermission = function (permission) {
        User
            .togglePermission($ctrl.user.id, permission.id)
            .then(
                function () {
                    permission.byPermission = !permission.byPermission;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };
}

export default 'usersControl.userPermissions';


// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/user-permissions/user-permissions.js